<div class="stars-container" *ngIf="stars" [class.read-only]="readOnly">
  <ng-container *ngFor="let star of stars; let i = index">
    <span
      *ngIf="star < starsRate"
      [inlineSVG]="selectedStarIcon"
      class="star-icon"
      title="Selected star"
      (click)="starClicked(index, star + 1)"
      [matTooltip]="'global.' + titlesDesc + '_' + (i + 1) | translate"
      [matTooltipDisabled]="disableStarTooltips"
      [matTooltipPosition]="'above'"
    >
    </span>
    <span
      *ngIf="star >= starsRate"
      [inlineSVG]="emptyStarIcon"
      class="star-icon empty-star"
      title="Empty star"
      (click)="starClicked(index, star + 1)"
      [matTooltip]="'global.' + titlesDesc + '_' + (i + 1) | translate"
      [matTooltipDisabled]="disableStarTooltips"
      [matTooltipPosition]="'above'"
    >
    </span>
  </ng-container>
</div>
